import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { api } from "../api";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";

const Sektorler = () => {
  const [sectors, setSectors] = useState([]);
  const [active, setActive] = useState(null);
  const { t } = useLang();

  useEffect(() => {
    api.sectors().then(setSectors).catch(() => {});
  }, []);

  return (
    <main className="bg-white">
      <SEO title={t("sectors.title")} description={t("sectors.subtitle")} path="/sektorler" />
      <PageHero kicker={t("sectors.kicker")} title={t("sectors.title")} subtitle={t("sectors.subtitle")} />

      <section className="pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {sectors.map((s, i) => (
              <article
                key={s.id}
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(null)}
                className="group relative rounded-2xl overflow-hidden bg-neutral-100 aspect-[4/5] cursor-pointer"
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-7 text-white">
                  <div className="text-xs tracking-[0.24em] uppercase text-[#C9A24B] font-semibold mb-2">
                    0{i + 1}
                  </div>
                  <h3 className="text-2xl md:text-3xl font-black">{s.title}</h3>
                  <p className="text-sm text-white/70 mt-1">{s.subtitle}</p>
                  <div
                    className={`overflow-hidden transition-[max-height,opacity] duration-500 ${
                      active === i ? "max-h-48 opacity-100 mt-4" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="text-[15px] text-white/85 leading-relaxed">{s.description}</p>
                  </div>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold">
                    {t("common.viewDetail")} <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Sektorler;
